import React from 'react';
import { toCurrency } from '@/shared/helpers';

const footerSum = (info, field) => {
  const total = info.rows.reduce((sum, row) => sum + Number(row.original[field] || 0), 0);
  return <span>{toCurrency(total)}</span>;
};

export const COCARD_REPORT_COLUMNS = [
  {
    Header: "Program Name",
    accessor: "name",
    Footer: "CoCard Total",
    minWidth: 180,
    noAlignRight: true,
  },
  {
    Header: "Program ID",
    accessor: "shownId",
    Footer: "",
    maxWidth: 100,
    noAlignRight: true,
    Cell: ({ row, value }) => value || row.original.account_holder_id,
  },
  {
    Header: "Program Funds net transfers",
    accessor: "program_funds_net_transfers",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'program_funds_net_transfers'),
  },
  {
    Header: "3% Award Fee",
    id: "award_fee",
    accessor: (row) => Number(row.program_funds_net_transfers || 0) * 0.03,
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => {
      const total = info.rows.reduce(
        (sum, row) => sum + Number(row.original.program_funds_net_transfers || 0) * 0.03,
        0
      );
      return <span>{toCurrency(total)}</span>;
    },
  },
  {
    Header: "Points Reclaimed",
    accessor: "reclaims",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'reclaims'),
  },
  {
    Header: "Points Purchased",
    accessor: "points_purchased",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'points_purchased'),
  },
  {
    Header: "ISO Balance Change",
    id: "iso_balance_change",
    accessor: (row) => Number(row.reclaims || 0) - Number(row.points_purchased || 0),
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => {
      const total = info.rows.reduce(
        (sum, row) =>
          sum + (Number(row.original.reclaims || 0) - Number(row.original.points_purchased || 0)),
        0
      );
      return <span>{toCurrency(total)}</span>;
    },
  },
  {
    Header: "Points Redeemed",
    accessor: "points_redeemed",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'points_redeemed'),
  },
  {
    Header: "Premium From Codes Redeemed",
    accessor: "codes_redeemed_premium",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'codes_redeemed_premium'),
  },
  {
    Header: "Cost of Codes Redeemed",
    accessor: "codes_redeemed_cost",
    Cell: ({ value }) => toCurrency(value),
    Footer: (info) => footerSum(info, 'codes_redeemed_cost'),
  },
];
